import { TicketLineDTO, Permission } from 'core/api';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { CustomerDisplay } from 'pos/services';
import { editLineAddins } from './editLineComposition';

declare global {
	interface CommandType {
		setTicketLineAddins: (line: TicketLineDTO) => Promise<Result>
	}
}

Command.register('setTicketLineAddins', Preconditions.ensure(Permission.Ticket_ComposeProduct), async (line: TicketLineDTO): Promise<Result> => {

	const result = await editLineAddins(line);

	if (!result.ok)
		return Result.error();

	await SalesStore.changeLineAddins(line.Id, result.value.addins);
	await CustomerDisplay.displayExistingLine(SalesStore.getTicket(), SalesStore.getLineById(line.Id));

	return Result.ok();
});